import script from "./SpotifyConnectButton.vue?vue&type=script&setup=true&lang=ts"
export * from "./SpotifyConnectButton.vue?vue&type=script&setup=true&lang=ts"

import "./SpotifyConnectButton.vue?vue&type=style&index=0&id=2c40fdfa&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2c40fdfa"]])

export default __exports__